import { render, staticRenderFns } from "./callCustomer.vue?vue&type=template&id=5ba6e4e7"
import script from "./callCustomer.vue?vue&type=script&lang=js"
export * from "./callCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports